import styled from "styled-components";
import { DialogTitle } from "@material-ui/core";

const Styles = styled(DialogTitle).attrs({
  classes: { root: "DialogTitle" }
})`
  &.DialogTitle {
    h2 {
      display: flex;
      justify-content: space-between;
      align-items: center;

      > svg {
        margin-right: 0.5em;
      }
    }

    button {
      margin-left: auto;
      text-align: center;
    }
  }
`;

export default Styles;
